var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_1109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 9.15703C7 8.55642 7.21022 8.06092 7.63063 7.67055C8.05105 7.28015 8.5976 7.08496 9.27027 7.08496C9.93094 7.08496 10.4655 7.27714 10.8739 7.66154C11.2943 8.05793 11.5045 8.57444 11.5045 9.21109C11.5045 9.78766 11.3003 10.2681 10.8919 10.6525C10.4715 11.0489 9.91892 11.2471 9.23423 11.2471H9.21622C8.55555 11.2471 8.02103 11.0489 7.61261 10.6525C7.2042 10.2561 7 9.75763 7 9.15703ZM7.23423 24.9228V12.8868H11.2342V24.9228H7.23423ZM13.4505 24.9228H17.4505V18.2021C17.4505 17.7816 17.4985 17.4573 17.5946 17.2291C17.7628 16.8207 18.018 16.4753 18.3604 16.1931C18.7027 15.9108 19.1321 15.7696 19.6487 15.7696C20.994 15.7696 21.6667 16.6765 21.6667 18.4904V24.9228H25.6667V18.0219C25.6667 16.2441 25.2463 14.8958 24.4054 13.9769C23.5646 13.0579 22.4535 12.5985 21.0721 12.5985C19.5225 12.5985 18.3153 13.2651 17.4505 14.5985V14.6345H17.4324L17.4505 14.5985V12.8868H13.4505C13.4745 13.2711 13.4865 14.4663 13.4865 16.4723C13.4865 18.4783 13.4745 21.2952 13.4505 24.9228Z",
    fill: "#09183D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_1109"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6.66675,
    width: 18.6667,
    height: 18.6667,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7df6fc25a0e5b1a6c9227b6f35ee7955.svg";
export { ForwardRef as ReactComponent };